import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule} from '@angular/forms';
import {NgxLinkifyjsModule} from 'ngx-linkifyjs';

import {ArchiveRoutingModule} from './archive-routing.module';
import {ArchiveComponent} from './archive/archive.component';
import {ArchiveListComponent} from './archive-list/archive-list.component';
import {FilterComponent} from './filter/filter.component';
import {ShowComponent} from './show/show.component';
import {SharedModule} from '../shared/shared.module';



@NgModule({
    declarations: [ArchiveComponent, ArchiveListComponent, FilterComponent, ShowComponent],
    imports: [
        CommonModule,
        SharedModule,
        ArchiveRoutingModule,
        FormsModule,
        NgSelectModule,
        NgxLinkifyjsModule,
    ],
    exports: [
    ],
    providers: []
})
export class ArchiveModule {
}
